// extracted by mini-css-extract-plugin
export default {"main":"EssayTextArea_main__x35wC","question":"EssayTextArea_question__AwZy-","tooltip":"EssayTextArea_tooltip__iRGq7","text_input":"EssayTextArea_text_input__p5hYe"};